<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row left-right-row">
                    <div class="left" />
                    <div class="right">
                        <div class="col-12">
                            <router-link
                                class="btn btn-success"
                                to="/office/service-products/new"
                            >
                                <i class="fa fa-plus" /> New Product
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <table
                            class="table"
                            v-if="products.length"
                        >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th class="text-center">
                                        Show on Inventory
                                    </th>
                                    <th class="text-center">
                                        Variations
                                    </th>
                                    <th><!-- options --></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(product, index) in products"
                                    :key="index"
                                >
                                    <td>
                                        <router-link :to="{name: 'office.service_products.edit', params: {id: product.id}}">
                                            {{ product.name }}
                                        </router-link>
                                    </td>
                                    <td class="text-center">
                                        {{ product.show_inventory ? 'Y' : 'N' }}
                                    </td>
                                    <td class="text-center">
                                        {{ product.variations.length }}
                                    </td>
                                    <td class="text-right">
                                        <router-link
                                            :to="{name: 'office.service_products.edit', params: {id: product.id}}"
                                            class="row-icon"
                                        >
                                            <i class="fa fa-pencil-alt" />
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Service from '../../../services/ServiceProductsService';

export default {
    data: function () {
        return {
            products: [],
        };
    },

    mounted: function () {
        Service.index().then(
            res => {
                this.products = res.data;
            });
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-products/SearchComponent.vue